function setFetchOptions({ state }) {
  state.set('client.fetchOptions', {
    skip: 0,
    limit: 30000,
    approved: true,
    sort: { lastname: 1 }
  })
}

export default setFetchOptions



// WEBPACK FOOTER //
// ./src/modules/app/actions/setFetchOptions.js